const QyMessageLog = {
    path: 'qyMessageLog',
    component: resolve => require(['@/pages/admin/message/qyMessageLog/list.vue'], resolve)
}

export default QyMessageLog